import {Model} from 'vue-mc';

export class ComercioModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
        clave : null
      , name: ""
      , email: ""
      , tipoArchivo: null
      , status: true
      , urlBuzonEntrada: ""
      , usuarioBuzonEntrada: ""
      , passwordBuzonEntrada:""
      // , urlBuzonRecepcion: ""
      // , usuarioBuzonRecepcion: ""
      // , passwordBuzonRecepcion: ""
      , puertoBuzonEntrada:null
      // , puertoBuzonRecepcion:null
      , locationAddress:""
      , locationCity:""
      , locationRegionCode:""
      , locationCountryCode:""
      , locationPostalCode:""
      , consecutivoArchivosGenerados:0
      , numeroComercio : null
      , formatoRespueta : "ORIGEN"
      , contenidoRespuesta: "RECHAZADOS"
      , summitterId : null
      , nombreArchivo: ""
      , nombreArchivoGSFG:""
      , nombreArchivoRespuesta:""
      , tiempoMaximoEsperaRespuesta: 2
      , esperaRespuesta: false
      , fechaFinEsperaRespuesta: ''
      , tiempoMaximoAdvertenciaRespuesta: 1
      , advertenciaRespuesta: false
      , fechaFinAdvertenciaRespuesta: ''
      , mcc: ''
      , multipleSucursal: false
      , sucursalEnEspera:null
      , nombreArchivoCartRefresh: ""
      , nombreArchivoCartRefreshCarga: ""
      , enviarCorreoSFTP: null
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      clave:clave=>clave
      , name:name=>name
      , email:email=>email
      , tipoArchivo:tipoArchivo=>tipoArchivo
      , status:status=>status
      , urlBuzonEntrada:urlBuzonEntrada=>urlBuzonEntrada
      , usuarioBuzonEntrada:usuarioBuzonEntrada=>usuarioBuzonEntrada
      , passwordBuzonEntrada:passwordBuzonEntrada=>passwordBuzonEntrada
      , puertoBuzonEntrada:puertoBuzonEntrada=>puertoBuzonEntrada
      , locationAddress: locationAddress => locationAddress
      , locationCity: locationCity => locationCity
      , locationRegionCode: locationRegionCode => locationRegionCode
      , locationCountryCode: locationCountryCode => locationCountryCode
      , locationPostalCode: locationPostalCode => locationPostalCode
      , consecutivoArchivosGenerados: consecutivoArchivosGenerados => consecutivoArchivosGenerados
      , numeroComercio:  numeroComercio =>  numeroComercio
      , formatoRespueta: formatoRespueta => formatoRespueta
      , contenidoRespuesta: contenidoRespuesta => contenidoRespuesta
      , summitterId: summitterId => summitterId
      , nombreArchivo: nombreArchivo => nombreArchivo
      , nombreArchivoGSFG: nombreArchivoGSFG=>nombreArchivoGSFG
      , nombreArchivoRespuesta: nombreArchivoRespuesta =>nombreArchivoRespuesta
      , tiempoMaximoEsperaRespuesta: tiempoMaximoEsperaRespuesta => tiempoMaximoEsperaRespuesta
      , esperaRespuesta: esperaRespuesta=>esperaRespuesta
      , fechaFinEsperaRespuesta: fechaFinEsperaRespuesta=>fechaFinEsperaRespuesta
      , tiempoMaximoAdvertenciaRespuesta: tiempoMaximoAdvertenciaRespuesta => tiempoMaximoAdvertenciaRespuesta
      , advertenciaRespuesta: advertenciaRespuesta => advertenciaRespuesta
      , fechaFinAdvertenciaRespuesta: fechaFinAdvertenciaRespuesta => fechaFinAdvertenciaRespuesta
      , mcc: mcc => mcc
      , multipleSucursal: multipleSucursal => multipleSucursal
      , sucursalEnEspera: sucursalEnEspera => sucursalEnEspera
      , nombreArchivoCartRefresh: nombreArchivoCartRefresh => nombreArchivoCartRefresh
      , nombreArchivoCartRefreshCarga: nombreArchivoCartRefreshCarga => nombreArchivoCartRefreshCarga
      , enviarCorreoSFTP: enviarCorreoSFTP => enviarCorreoSFTP
      
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

}



// WEBPACK FOOTER //
// ./src/models/generales/comercio.js